import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ShortUrlService {

  constructor(private http: HttpClient) { }

  getById(id: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/shorturl/${id}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/shorturl.service.ts